export class UpdateQuotePartsMessage { 
  quotePartIds: number[]

  constructor(quotePartIds: number[]) {
    this.quotePartIds = quotePartIds
  }
}